import { log } from '@/log'

/**
 * - 出荷前後の状態による分岐
 * - 過去のデータの解釈
 * - ラベルの翻訳
 * などを行う
 */
export const getOrderHistoryDeliveryMethodLabel = (deps: {
  purchaseDeliveryMethod: string,
  purchaseDeliveryMethodLabel: string,
  shippingActualDeliveryMethodLabel: string | undefined,
  unattendedDeliveryLabel: string | undefined,
}): string => {
  const concatUnattendedDeliveryLabel = (label: string): string =>
    deps.unattendedDeliveryLabel
      ? `${label} - ${deps.unattendedDeliveryLabel}`
      : label

  /**
   * (1) 実際の配送方法 shippingActualDeliveryMethodLabel を採用する
   *
   * 2025/03より古いデータには存在しない
   * 新しいデータであっても出荷前は存在しない
   *
   * 存在する場合はこれを採用する
   */
  if (deps.shippingActualDeliveryMethodLabel) {
    return concatUnattendedDeliveryLabel(deps.shippingActualDeliveryMethodLabel)
  }

  /**
   * (2) 注文時に指定した配送方法 purchaseDeliveryMethod を採用する
   *
   * ただし、注文時にはコンパクトを宅配便と翻訳しているため、注文履歴でもコンパクトと翻訳する
   * App\Gateway\Model\Delivery\DeliveryMethod\Repository\Engine\Builder\EngineDeliveryMethodBuilder
   * と同様のマッピングを行う必要がある
   */
  switch (deps.purchaseDeliveryMethod) {
    case 'standard':
    case 'compact':
      return concatUnattendedDeliveryLabel('宅配便')
    case 'standard-okihai':
    case 'compact-okihai':
      return concatUnattendedDeliveryLabel('置き配')
    case 'posting':
      return concatUnattendedDeliveryLabel('ポスト投函')
    case 'ヤマト宅急便':
    case '宅急便コンパクト':
      return concatUnattendedDeliveryLabel('宅急便（ヤマト運輸）')
    case 'ネコポス':
      return concatUnattendedDeliveryLabel('ポスト投函（ヤマト運輸）')
    default:
      log.warn('unexpected name, use as fallback:', deps.purchaseDeliveryMethodLabel)

      return concatUnattendedDeliveryLabel(deps.purchaseDeliveryMethodLabel)
  }
}
